import React, {FC} from 'react';
import cn from 'classnames';
import {useLocalizer} from '@/common/services/localizer';
import styles from './GlobalErrorMessage.css';

interface GlobalErrorMessageProps {
	className?: string;
}

export const GlobalErrorMessage: FC<GlobalErrorMessageProps> = props => {
	const {className} = props;
	const t = useLocalizer();

	return <div className={cn(styles.root, className)}>{t('unknownError')}</div>;
};

GlobalErrorMessage.displayName = 'GlobalErrorMessage';
